function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m8 .6665-6 2.6667v4c0 3.7 2.56 7.16 6 8 3.44-.84 6-4.3 6-8v-4l-6-2.6667zm0 4c.93333 0 1.8667.73334 1.8667 1.6667v1c.40003 0 .80003.4.80003.86667v2.3334c0 .4-.4.8-.8667.8h-3.6667c-.4 0-.8-.4-.8-.8667v-2.3333c0-.4.4-.8.8-.8v-1c0-.93333.93334-1.6667 1.8667-1.6667zm0 .8c-.53333 0-1 .33334-1 .86667v1h2v-1c0-.53333-.46667-.86667-1-.86667z",
  fill: "currentColor"
}));
function SvgShieldLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "static/2.5.1/media/shieldLock.7a5d393a.svg";
export { SvgShieldLock as ReactComponent };